var _path, _circle, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 21.18V18C25.9986 16.5831 25.4958 15.2125 24.5806 14.1308C23.6655 13.0491 22.3971 12.3261 21 12.09V11C21 10.7348 20.8946 10.4804 20.7071 10.2929C20.5196 10.1054 20.2652 10 20 10C19.7348 10 19.4804 10.1054 19.2929 10.2929C19.1054 10.4804 19 10.7348 19 11V12.09C17.6029 12.3261 16.3345 13.0491 15.4194 14.1308C14.5042 15.2125 14.0014 16.5831 14 18V21.18C13.4165 21.3863 12.911 21.7681 12.5529 22.2729C12.1949 22.7778 12.0017 23.3811 12 24V26C12 26.2652 12.1054 26.5196 12.2929 26.7071C12.4804 26.8946 12.7348 27 13 27H16.14C16.3703 27.8474 16.873 28.5954 17.5706 29.1287C18.2682 29.6621 19.1219 29.951 20 29.951C20.8781 29.951 21.7318 29.6621 22.4294 29.1287C23.127 28.5954 23.6297 27.8474 23.86 27H27C27.2652 27 27.5196 26.8946 27.7071 26.7071C27.8946 26.5196 28 26.2652 28 26V24C27.9983 23.3811 27.8051 22.7778 27.4471 22.2729C27.089 21.7681 26.5835 21.3863 26 21.18ZM16 18C16 16.9391 16.4214 15.9217 17.1716 15.1716C17.9217 14.4214 18.9391 14 20 14C21.0609 14 22.0783 14.4214 22.8284 15.1716C23.5786 15.9217 24 16.9391 24 18V21H16V18ZM20 28C19.651 27.9979 19.3086 27.9045 19.0068 27.7291C18.7051 27.5536 18.4545 27.3023 18.28 27H21.72C21.5455 27.3023 21.2949 27.5536 20.9932 27.7291C20.6914 27.9045 20.349 27.9979 20 28ZM26 25H14V24C14 23.7348 14.1054 23.4804 14.2929 23.2929C14.4804 23.1054 14.7348 23 15 23H25C25.2652 23 25.5196 23.1054 25.7071 23.2929C25.8946 23.4804 26 23.7348 26 24V25Z",
    fill: "#565758"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 6,
    r: 4,
    fill: "#F84E4E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#696A6B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyIcon);
export default __webpack_public_path__ + "static/media/notifyIcon.967c6fca05cc1a58d862a1e1acaa0938.svg";
export { ForwardRef as ReactComponent };